
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * 正誤結果表示チップ
 */
@Component({
  components: {
    ImageBase,
  },
})
export default class QuestionResultTip extends Vue {
  /** 正誤結果 */
  @Prop()
  private isCorrect!: boolean
}
